import PathConstants from '@/main/routes/paths'
import { SvgIconComponent } from '@mui/icons-material'
import { ListItemButtonProps, ListItemIcon, MenuItem, Typography, useTheme } from '@mui/material'
import { ForwardRefExoticComponent, Fragment, RefAttributes } from 'react'
import { LinkProps, useLocation, useParams } from 'react-router-dom'
import { AnalyticsEventName, AnalyticsTracker } from '@/infra/tracking'

type MenuItemAppProps = {
  toRoute: PathConstants.RouteProps
  availableIn?: PathConstants.RouteProps[]
  icon?: SvgIconComponent
  component: ForwardRefExoticComponent<LinkProps & RefAttributes<HTMLAnchorElement>>
  target?: string
  rel?: string
  onClose: () => void
} & ListItemButtonProps

export function MenuItemApp({
  component,
  toRoute,
  availableIn = [],
  icon: Icon,
  onClose,
  ...props
}: MenuItemAppProps) {
  const theme = useTheme()
  const location = useLocation()
  const params = useParams()
  availableIn.push(toRoute)
  const routeOfThisItem: boolean = availableIn.some(
    route => (route.computeValue ? route.computeValue(params) : route.value) === location.pathname
  )

  const handleClick = () => {
    if (toRoute.name) {
      AnalyticsTracker.trackEvent(AnalyticsEventName.HEADER_NAVIGATE, {
        destination: toRoute.name
      })
    }
    onClose()
  }

  return (
    <Fragment>
      <MenuItem
        component={component}
        to={toRoute.value}
        sx={{ py: theme.spacing(7 / 8), px: theme.spacing(3) }}
        onClick={handleClick}
        {...props}
      >
        {Icon && (
          <ListItemIcon>
            <Icon
              color={routeOfThisItem ? 'primary' : undefined}
              sx={routeOfThisItem ? {} : { color: 'grey.900' }}
            />
          </ListItemIcon>
        )}
        <Typography
          variant="body1"
          color={routeOfThisItem ? 'primary' : 'grey.900'}
          fontWeight={routeOfThisItem ? 'bold' : 'inherit'}
        >
          {toRoute.title}
        </Typography>
      </MenuItem>
    </Fragment>
  )
}
